/* BreezeBuy mobile sticky Add to cart. Presses the main Add to cart button, so the theme's own cart logic runs. */
if (!customElements.get('bb-sticky-atc')) {
  customElements.define(
    'bb-sticky-atc',
    class BBStickyATC extends HTMLElement {
      connectedCallback() {
        this.info = document.querySelector("product-info[id^='MainProduct']") || document.querySelector('product-info');
        this.btn = this.querySelector('[data-bb-btn]');
        this.priceEl = this.querySelector('[data-bb-price]');
        if (!this.info || !this.btn) return;
        this.sid = this.info.dataset.originalSection || this.info.dataset.section;
        const main = this.main();
        if (!main) return;
        this.state = { past: false, footer: false };
        this.observers = [];
        this.inert = true;

        this.btn.addEventListener('click', () => {
          const m = this.main();
          if (m && !m.disabled) m.click();
        });

        const mo = new MutationObserver(() => this.sync());
        mo.observe(main, {
          attributes: true,
          attributeFilter: ['disabled', 'class', 'aria-disabled'],
          childList: true,
          subtree: true,
          characterData: true,
        });
        this.observers.push(mo);

        const box = document.getElementById('price-' + this.sid);
        if (box) {
          const po = new MutationObserver(() => this.syncPrice());
          po.observe(box, { childList: true, subtree: true, characterData: true });
          this.observers.push(po);
        }

        const anchor = main.closest('.product-form__buttons') || main;
        const io = new IntersectionObserver(([e]) => {
          this.state.past = !e.isIntersecting && e.boundingClientRect.top < 0;
          this.render();
        });
        io.observe(anchor);
        this.observers.push(io);

        const footer = document.querySelector('footer');
        if (footer) {
          const fo = new IntersectionObserver(([e]) => {
            this.state.footer = e.isIntersecting;
            this.render();
          });
          fo.observe(footer);
          this.observers.push(fo);
        }

        this.sync();
        this.syncPrice();
      }

      disconnectedCallback() {
        if (this.observers) this.observers.forEach((o) => o.disconnect());
      }

      main() {
        return document.getElementById('ProductSubmitButton-' + this.sid);
      }

      render() {
        const show = this.state.past && !this.state.footer;
        this.classList.toggle('is-visible', show);
        this.inert = !show;
        this.setAttribute('aria-hidden', String(!show));
      }

      sync() {
        const m = this.main();
        if (!m) return;
        const label = m.querySelector('span');
        if (label && label.textContent.trim()) this.btn.textContent = label.textContent.trim();
        this.btn.disabled = m.disabled;
        const busy = m.classList.contains('loading');
        this.btn.classList.toggle('is-loading', busy);
        this.btn.setAttribute('aria-busy', String(busy));
      }

      syncPrice() {
        const box = document.getElementById('price-' + this.sid);
        if (!box || !this.priceEl) return;
        const onSale = !!box.querySelector('.price--on-sale');
        const cur = onSale
          ? box.querySelector('.price__sale .price-item--sale')
          : box.querySelector('.price__regular .price-item--regular');
        if (!cur) return;
        const was = onSale ? box.querySelector('.price__sale s.price-item--regular') : null;
        this.priceEl.textContent = '';
        if (was) {
          const s = document.createElement('s');
          s.textContent = was.textContent.trim();
          this.priceEl.append(s);
        }
        this.priceEl.append(cur.textContent.trim());
      }
    }
  );
}